/*eslint-disable*/
export const INVITATION_SENT_STATUS = 'invitation_sent';
export const INVITATION_DECLINED_STATUS = 'invitation_declined';
export const INVITATION_ACCEPTED_STATUS = 'invitation_accepted';

export const DECLINE_INVITATION = 'declineInvitation';
export const IGNORE_INVITATION = 'ignoreInvitation';